import css from 'styled-jsx/css';
import { colors, common, zIndex } from '../../../theme/theme';

const style = css.global`
  .claim-image-annotate-modal .ant-modal {
    max-width: none;
  }
  .claim-image-annotate-modal .ant-modal-body {
    padding: 0 8px;
  }
  .claim-image-annotate-modal .ant-modal-footer {
    margin-top: 0;
    padding: 8px 8px 4px;
  }
  .claim-image-annotate-editor {
    position: relative;
    height: calc(100vh - 175px);
    min-height: 440px;
  }
  .claim-image-annotate-editor .FIE_root {
    height: 100%;
  }
  /* Only the Annotate tab is exposed, so the tab sidebar is an empty column. */
  .claim-image-annotate-editor .FIE_tabs {
    display: none;
  }
  .claim-image-annotate-editor .FIE_editor-content {
    width: 100%;
  }
  .claim-image-annotate-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .claim-image-annotate-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }
  .claim-image-annotate-footer .submit-button,
  .claim-image-annotate-confirm-body .submit-button {
    ${common.button}
    ${common.submitButton}
  }
  .claim-image-annotate-footer .cancel-button,
  .claim-image-annotate-confirm-body .cancel-button {
    ${common.button}
    ${common.cancelButton}
  }
  .claim-image-annotate-footer .submit-button,
  .claim-image-annotate-footer .cancel-button {
    width: auto;
    min-width: 180px;
    margin: 0;
  }
  .claim-image-annotate-footer .submit-button:disabled {
    color: #fff;
    background: #313131;
    opacity: 0.4;
  }
  .claim-image-annotate-confirm-body {
    padding: 8px 4px 0;
  }
  .claim-image-annotate-confirm-title {
    font-size: 16px;
    font-weight: 500;
    color: black;
    margin-bottom: 12px;
  }
  .claim-image-annotate-confirm-body p {
    font-size: 14px;
    color: #313131;
    margin-bottom: 20px;
  }
  /* Filerobot renders its colour picker (z 1301) and option poppers (z 1200)
     into body-level portals, below the antd modal; lift them above it. */
  [class*='SfxPopper-'],
  [class*='SfxModal-'] {
    z-index: ${zIndex.annotateModal + 20} !important;
  }
  /* Filerobot's slider base sets a purple currentColor the palette cannot reach. */
  .claim-image-annotate-editor .SfxSlider-root,
  [class*='SfxPopper-'] .SfxSlider-root {
    color: ${colors.editorAccent};
  }
`;

export default style;
